import type {PermissionType} from '@hconnect/apiclient'
import {useUpmPlant} from '@hconnect/upm'
import {useMemo} from 'react'

import {useUrlParam} from '../../routing'
import {checkPermissionAccessByDataScope} from '../helpers/checkPermissionAccessByDataScope'

import {usePermissionsQuery} from './queries'

export const useAnyPermission = (...types: PermissionType[]): boolean => {
  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId: plantCode, shouldRaiseError: false})

  const {data: permissions} = usePermissionsQuery(types)

  return useMemo(() => {
    if (!permissions || !upmPlant) return false

    return permissions.some(
      (permission) =>
        types.includes(permission.permissionType) &&
        checkPermissionAccessByDataScope(upmPlant.country, plantCode, permission.parsedDataScope)
    )
  }, [permissions, upmPlant, types, plantCode])
}
